import {AfterViewInit, Component, DestroyRef, inject, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractPortalComponent} from "../abstract-portal/abstract-portal.component";
import {LocaleService} from "../../../service/locale.service";
import {isEmpty, TranslocoService} from "@ngneat/transloco";
import {filter, Observable, pluck, Subject, Subscription, take, takeUntil} from "rxjs";
import {PageCommonsService} from "../../../service/page-commons.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";



@Component({
  selector: 'app-abstract-lazy',
  standalone: true,
  imports: [CommonModule],
  template: ''
})
export abstract class AbstractLazyComponent extends AbstractPortalComponent implements AfterViewInit, OnInit{

  #destroyRef = inject(DestroyRef);

  isLoaded = false;
  transloco = inject(TranslocoService);
  protected pageCommonsService = inject( PageCommonsService)
  currentLocale : String;

  constructor(localeService: LocaleService) {
    super(localeService);
    this.currentLocale = localeService.currentLocale;

  }

  ngAfterViewInit(): void {
    const destroyListener$: Subject<void> = new Subject();
    this.transloco.langChanges$
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe( (lang: string) => {
        if(this.currentLocale !== lang){
          this.ngOnLanguageChange();
          this.currentLocale = lang;
        }
      })
  }

  ngOnInit(): void {
  }

  ngOnLanguageChange() {
  }



}
